module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 28
// module chunks = 0 1